import { Link } from "react-router-dom";
import { useDemoRequest } from "@/components/feature/DemoRequest";

export default function BespokeCTA() {
  const { open } = useDemoRequest();
  return (
    <section className="py-16 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            Need a system built around your business?
          </h2>
          <p className="text-base md:text-lg text-silver-300 mb-8 max-w-xl mx-auto">
            Let's design a solution that fits how you operate.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button onClick={open} className="btn-primary w-full sm:w-auto text-center whitespace-nowrap cursor-pointer">
              Request a Demo
            </button>
            <Link
              to="/contact"
              className="btn-outline w-full sm:w-auto text-center whitespace-nowrap cursor-pointer"
            >
              Talk to Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}